import { useEffect } from 'react';

import { Button, Container, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

export function LogoutPage() {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <Container size="sm">
      <Stack align="center" gap="lg" py="xl">
        <Title order={1}>Thank You!</Title>
        <Text>You have been successfully logged out.</Text>
        <Button component={Link} to="/login" variant="outline" color="purple.7">
          Log In Again
        </Button>
      </Stack>
    </Container>
  );
}
